/**
 * Geometría de la vista previa en vivo de la zona Apariencia (`PortalAppearanceZone`).
 *
 * El portal se dibuja a ancho de ESCRITORIO y se escala para entrar entero en la columna. Antes el
 * iframe medía 1024px dentro de una columna de ~500 y se paneaba con scroll horizontal: la agencia
 * veía el portal cortado, sin el header completo (card E5J1Cqzu).
 */
export const PREVIEW_DESKTOP_WIDTH = 1024;

// Por debajo de esta escala el portal deja de leerse (a 0,5 una letra de 14px ya mide 7). En una
// columna angosta —el teléfono— no se sigue achicando: se angosta el ancho con el que se dibuja el
// portal, que pasa a su layout angosto, el mismo que vería el cliente en esa pantalla.
export const PREVIEW_MIN_SCALE = 0.5;

/**
 * `boxWidth`/`boxHeight`: lo que mide la caja visible. Devuelve el tamaño con el que se dibuja el
 * iframe y la escala que lo lleva a la caja; `null` si la caja todavía no se midió.
 */
export function previewFrameGeometry(boxWidth, boxHeight) {
    if (!(boxWidth > 0) || !(boxHeight > 0)) return null;
    // Una caja más ancha que el escritorio no agranda el portal: se dibuja a su ancho, en escala 1.
    const width = boxWidth >= PREVIEW_DESKTOP_WIDTH
        ? boxWidth
        : Math.min(PREVIEW_DESKTOP_WIDTH, boxWidth / PREVIEW_MIN_SCALE);
    const scale = boxWidth / width;
    return {width, height: boxHeight / scale, scale};
}
